<div appModal [mainClass]="isMobile ? 'xs-modal' : 'xs-s-modal'" (closeModal)="close()">
  <section>
    <section *ngIf="!isMobile">
      <div class="header-section mt-15">
        <h2>Share your clip on Instagram</h2>
        <div>
          Enter your mobile number and we'll text you a link so you can download the clip on your mobile device and
          upload it in the Instagram app
        </div>
      </div>

      <section class="form-section">
        <form [formGroup]="igShareForm">
          <div class="input input-text" [class.input-error]="fhs.isInputInvalid(igShareForm, 'phoneNumber')">
            <input
              appPhoneNumberFormat
              type="tel"
              #phoneNumberInput
              placeholder="Phone Number"
              formControlName="phoneNumber"
              autocomplete="off"
              [tabIndex]="2"
            />
          </div>
        </form>
      </section>

      <div *ngIf="summaryErrorMessage" class="my-20 text-sienna">{{ summaryErrorMessage }}</div>

      <section class="clip-modal__actions">
        <button alt="Cancel" class="btn btn-wide clip-modal__actions--cancel" (click)="close()">Cancel</button>
        <button alt="Save" class="btn btn-wide ml-21 clip-modal__actions--apply" (click)="save()">Send</button>
      </section>
    </section>

    <section *ngIf="isMobile">
      <div class="header-section mt-15">
        <h2>Click to download your clip</h2>
        <div class="download-subtext">Download your clip and upload it on the Instagram app.</div>
      </div>
      <div class="mt-25">
        <img *ngIf="this.video?.urlThumb" alt="Video thumbnail" class="video-thumb" [src]="this.video?.urlThumb" />
        <img
          *ngIf="!this.video?.urlThumb"
          alt="Video thumbnail"
          class="video-thumb"
          src="assets/images/video-placeholder/video-placeholder-ig.jpg"
          srcset="
            assets/images/video-placeholder/video-placeholder-ig@2x.jpg 2x,
            assets/images/video-placeholder/video-placeholder-ig@3x.jpg 3x
          "
        />
        <div class="video-title mt-8">{{ video?.name }}</div>
        <div class="video-date mt-5">{{ video?.createdAt | date: 'MMMM d, y' }}</div>
      </div>
      <div class="mobile-actions">
        <button
          alt="Download"
          class="btn btn-wide clip-modal__actions--apply download-btn"
          (click)="download($event, true)"
        >
          Download
        </button>
      </div>
    </section>
  </section>
</div>
